import { j as g } from "./jsx-runtime-CZlWR0BA.js";
import { H as c } from "./styled-components.browser.esm-CdvvWRMU.js";
const t = {
  "accessibility-alt": {
    bold: "\f101",
    fill: "\f102",
    regular: "\f103"
  },
  accessibility: {
    bold: "\f104",
    fill: "\f105",
    regular: "\f106"
  },
  activity: {
    bold: "\f107",
    fill: "\f108",
    regular: "\f109"
  },
  "add-document": {
    bold: "\f10a",
    fill: "\f10b",
    regular: "\f10c"
  },
  "add-image": {
    bold: "\f10d",
    fill: "\f10e",
    regular: "\f10f"
  },
  agenda: {
    bold: "\f110",
    fill: "\f111",
    regular: "\f112"
  },
  analytics: {
    bold: "\f113",
    fill: "\f114",
    regular: "\f118"
  },
  "analytics-raise": {
    bold: "\f115",
    fill: "\f116",
    regular: "\f117"
  },
  apple: {
    bold: "\f119",
    fill: "\f11a",
    regular: "\f11b"
  },
  "arrow-down": {
    bold: "\f11c",
    fill: "\f11d",
    regular: "\f11e"
  },
  "arrow-left": {
    bold: "\f11f",
    fill: "\f120",
    regular: "\f121"
  },
  "arrow-right": {
    bold: "\f122",
    fill: "\f123",
    regular: "\f124"
  },
  "arrow-up": {
    bold: "\f125",
    fill: "\f126",
    regular: "\f127"
  },
  assistant: {
    bold: "\f128",
    fill: "\f129",
    regular: "\f12a"
  },
  "bag-of-flour": {
    bold: "\f12b",
    fill: "\f12c",
    regular: "\f12d"
  },
  "bag-with-gift": {
    bold: "\f12e",
    fill: "\f12f",
    regular: "\f130"
  },
  bags: {
    bold: "\f131",
    fill: "\f132",
    regular: "\f133"
  },
  balance: {
    bold: "\f134",
    fill: "\f135",
    regular: "\f136"
  },
  "battery-alt": {
    bold: "\f137",
    fill: "\f138",
    regular: "\f139"
  },
  "battery-charginig": {
    bold: "\f13a",
    fill: "\f13b",
    regular: "\f13c"
  },
  "battery-full": {
    bold: "\f13d",
    fill: "\f13e",
    regular: "\f13f"
  },
  "battery-half": {
    bold: "\f140",
    fill: "\f141",
    regular: "\f142"
  },
  "battery-low": {
    bold: "\f143",
    fill: "\f144",
    regular: "\f145"
  },
  bell: {
    bold: "\f146",
    fill: "\f147",
    regular: "\f14e"
  },
  "bell-new-message": {
    bold: "\f148",
    fill: "\f149",
    regular: "\f14a"
  },
  "bell-off": {
    bold: "\f14b",
    fill: "\f14c",
    regular: "\f14d"
  },
  bicycle: {
    bold: "\f14f",
    fill: "\f150",
    regular: "\f151"
  },
  "bookmark-simple": {
    bold: "\f152",
    fill: "\f153",
    regular: "\f154"
  },
  bowl: {
    bold: "\f155",
    fill: "\f156",
    regular: "\f157"
  },
  "box-milk": {
    bold: "\f158",
    fill: "\f159",
    regular: "\f15a"
  },
  "bus-front": {
    bold: "\f15b",
    fill: "\f15c",
    regular: "\f15d"
  },
  butter: {
    bold: "\f15e",
    fill: "\f15f",
    regular: "\f160"
  },
  cake: {
    bold: "\f161",
    fill: "\f162",
    regular: "\f163"
  },
  calculator: {
    bold: "\f164",
    fill: "\f165",
    regular: "\f166"
  },
  calendar: {
    bold: "\f167",
    fill: "\f168",
    regular: "\f16f"
  },
  "calendar-history-alt": {
    bold: "\f169",
    fill: "\f16a",
    regular: "\f16b"
  },
  "calendar-history": {
    bold: "\f16c",
    fill: "\f16d",
    regular: "\f16e"
  },
  "call-center": {
    bold: "\f170",
    fill: "\f171",
    regular: "\f172"
  },
  camera: {
    bold: "\f173",
    fill: "\f174",
    regular: "\f175"
  },
  can: {
    bold: "\f176",
    fill: "\f177",
    regular: "\f178"
  },
  candy: {
    bold: "\f179",
    fill: "\f17a",
    regular: "\f17b"
  },
  "caret-down": {
    bold: "\f17c",
    fill: "\f17d",
    regular: "\f17e"
  },
  "caret-left": {
    bold: "\f17f",
    fill: "\f180",
    regular: "\f181"
  },
  "caret-right": {
    bold: "\f182",
    fill: "\f183",
    regular: "\f184"
  },
  "caret-up": {
    bold: "\f185",
    fill: "\f186",
    regular: "\f187"
  },
  cell: {
    bold: "\f188",
    fill: "\f189",
    regular: "\f18a"
  },
  "cells-document": {
    bold: "\f18b",
    fill: "\f18c",
    regular: "\f18d"
  },
  "chart-bar": {
    bold: "\f18e",
    fill: "\f18f",
    regular: "\f190"
  },
  "chart-pie-slice": {
    bold: "\f191",
    fill: "\f192",
    regular: "\f193"
  },
  "chat-circle-text": {
    bold: "\f194",
    fill: "\f195",
    regular: "\f196"
  },
  check: {
    bold: "\f197",
    fill: "\f198",
    regular: "\f199"
  },
  "chemical-experiment": {
    bold: "\f19a",
    fill: "\f19b",
    regular: "\f19c"
  },
  "chemical-test": {
    bold: "\f19d",
    fill: "\f19e",
    regular: "\f19f"
  },
  "chocolate-bar": {
    bold: "\f1a0",
    fill: "\f1a1",
    regular: "\f1a2"
  },
  cleaner: {
    bold: "\f1a3",
    fill: "\f1a7",
    regular: "\f1a8"
  },
  "cleaner-dispenser": {
    bold: "\f1a4",
    fill: "\f1a5",
    regular: "\f1a6"
  },
  clock: {
    bold: "\f1a9",
    fill: "\f1aa",
    regular: "\f1ab"
  },
  "close-full-screen": {
    bold: "\f1ac",
    fill: "\f1ad",
    regular: "\f1ae"
  },
  "cloud-offline": {
    bold: "\f1af",
    fill: "\f1b0",
    regular: "\f1b1"
  },
  "cloud-problem": {
    bold: "\f1b2",
    fill: "\f1b3",
    regular: "\f1b4"
  },
  coffee: {
    bold: "\f1b5",
    fill: "\f1b6",
    regular: "\f1b7"
  },
  comments: {
    bold: "\f1b8",
    fill: "\f1b9",
    regular: "\f1ba"
  },
  cookie: {
    bold: "\f1bb",
    fill: "\f1bc",
    regular: "\f1bd"
  },
  copy: {
    bold: "\f1be",
    fill: "\f1bf",
    regular: "\f1c0"
  },
  "credit-card": {
    bold: "\f1c1",
    fill: "\f1c2",
    regular: "\f1c3"
  },
  "crop-alt": {
    bold: "\f1c4",
    fill: "\f1c5",
    regular: "\f1c6"
  },
  crop: {
    bold: "\f1c7",
    fill: "\f1c8",
    regular: "\f1cc"
  },
  "crop-health": {
    bold: "\f1c9",
    fill: "\f1ca",
    regular: "\f1cb"
  },
  "delivery-guy": {
    bold: "\f1cd",
    fill: "\f1ce",
    regular: "\f1cf"
  },
  density: {
    bold: "\f1d0",
    fill: "\f1d1",
    regular: "\f1d2"
  },
  detergent: {
    bold: "\f1d3",
    fill: "\f1d4",
    regular: "\f1d5"
  },
  "document-upload": {
    bold: "\f1d6",
    fill: "\f1d7",
    regular: "\f1d8"
  },
  "dots-three": {
    bold: "\f1d9",
    fill: "\f1da",
    regular: "\f1db"
  },
  "download-alt": {
    bold: "\f1dc",
    fill: "\f1dd",
    regular: "\f1de"
  },
  download: {
    bold: "\f1df",
    fill: "\f1e0",
    regular: "\f1e1"
  },
  dron: {
    bold: "\f1e2",
    fill: "\f1e3",
    regular: "\f1e4"
  },
  education: {
    bold: "\f1e5",
    fill: "\f1e6",
    regular: "\f1e7"
  },
  envelope: {
    bold: "\f1e8",
    fill: "\f1e9",
    regular: "\f1ed"
  },
  "envelope-new-message": {
    bold: "\f1ea",
    fill: "\f1eb",
    regular: "\f1ec"
  },
  equals: {
    bold: "\f1ee",
    fill: "\f1ef",
    regular: "\f1f0"
  },
  eraser: {
    bold: "\f1f1",
    fill: "\f1f2",
    regular: "\f1f3"
  },
  excel: {
    bold: "\f1f4",
    fill: "\f1f8",
    regular: "\f1f9"
  },
  "excel-download": {
    bold: "\f1f5",
    fill: "\f1f6",
    regular: "\f1f7"
  },
  exit: {
    bold: "\f1fa",
    fill: "\f1fb",
    regular: "\f1fc"
  },
  eye: {
    bold: "\f1fd",
    fill: "\f1fe",
    regular: "\f1ff"
  },
  "eye-slash": {
    bold: "\f200",
    fill: "\f201",
    regular: "\f202"
  },
  "face-satisfied": {
    bold: "\f203",
    fill: "\f204",
    regular: "\f205"
  },
  "face-dissatisfied": {
    bold: "\f206",
    fill: "\f207",
    regular: "\f208"
  },
  "face-mask": {
    bold: "\f209",
    fill: "\f20a",
    regular: "\f20b"
  },
  facebook: {
    bold: "\f20c",
    fill: "\f20d",
    regular: "\f20e"
  },
  "fast-truck": {
    bold: "\f20f",
    fill: "\f210",
    regular: "\f211"
  },
  "favorite-calendar": {
    bold: "\f212",
    fill: "\f213",
    regular: "\f214"
  },
  "favorite-medal": {
    bold: "\f215",
    fill: "\f216",
    regular: "\f217"
  },
  "favorite-package": {
    bold: "\f218",
    fill: "\f219",
    regular: "\f21a"
  },
  feeder: {
    bold: "\f21b",
    fill: "\f21c",
    regular: "\f21d"
  },
  file: {
    bold: "\f21e",
    fill: "\f222",
    regular: "\f223"
  },
  "file-download": {
    bold: "\f21f",
    fill: "\f220",
    regular: "\f221"
  },
  filter: {
    bold: "\f224",
    fill: "\f225",
    regular: "\f226"
  },
  fingerprint: {
    bold: "\f227",
    fill: "\f228",
    regular: "\f229"
  },
  fire: {
    bold: "\f22a",
    fill: "\f22b",
    regular: "\f22c"
  },
  fireworks: {
    bold: "\f22d",
    fill: "\f22e",
    regular: "\f22f"
  },
  "first-place": {
    bold: "\f230",
    fill: "\f231",
    regular: "\f232"
  },
  fish: {
    bold: "\f233",
    fill: "\f234",
    regular: "\f235"
  },
  flag: {
    bold: "\f236",
    fill: "\f237",
    regular: "\f238"
  },
  forward: {
    bold: "\f239",
    fill: "\f23a",
    regular: "\f23b"
  },
  "full-volume": {
    fill: "\f23c",
    bold: "\f240",
    regular: "\f241"
  },
  "full-screen": {
    bold: "\f23d",
    fill: "\f23e",
    regular: "\f23f"
  },
  gear: {
    bold: "\f242",
    fill: "\f243",
    regular: "\f244"
  },
  gift: {
    bold: "\f245",
    fill: "\f249",
    regular: "\f24a"
  },
  "gift-delivery": {
    bold: "\f246",
    fill: "\f247",
    regular: "\f248"
  },
  globe: {
    bold: "\f24b",
    fill: "\f24c",
    regular: "\f24d"
  },
  grid: {
    bold: "\f24e",
    fill: "\f24f",
    regular: "\f250"
  },
  "group-bigger": {
    bold: "\f251",
    fill: "\f252",
    regular: "\f253"
  },
  group: {
    bold: "\f254",
    fill: "\f255",
    regular: "\f256"
  },
  "half-volume": {
    bold: "\f257",
    fill: "\f258",
    regular: "\f259"
  },
  hamburger: {
    bold: "\f25a",
    fill: "\f25b",
    regular: "\f25c"
  },
  handbag: {
    bold: "\f25d",
    fill: "\f25e",
    regular: "\f25f"
  },
  "happy-chip": {
    bold: "\f260",
    fill: "\f261",
    regular: "\f262"
  },
  healthy: {
    bold: "\f263",
    fill: "\f264",
    regular: "\f265"
  },
  heart: {
    bold: "\f266",
    fill: "\f267",
    regular: "\f268"
  },
  "history-time": {
    bold: "\f269",
    fill: "\f26a",
    regular: "\f26b"
  },
  home: {
    bold: "\f26c",
    fill: "\f26d",
    regular: "\f26e"
  },
  hydrophone: {
    bold: "\f26f",
    fill: "\f270",
    regular: "\f271"
  },
  "ice-cream": {
    bold: "\f272",
    fill: "\f273",
    regular: "\f274"
  },
  idea: {
    bold: "\f275",
    fill: "\f276",
    regular: "\f277"
  },
  identification: {
    bold: "\f278",
    fill: "\f279",
    regular: "\f27a"
  },
  image: {
    regular: "\f27b",
    bold: "\f27c",
    fill: "\f27d"
  },
  info: {
    bold: "\f27e",
    fill: "\f27f",
    regular: "\f280"
  },
  instagram: {
    bold: "\f281",
    fill: "\f282",
    regular: "\f283"
  },
  "intelligence-a-i": {
    bold: "\f284",
    fill: "\f285",
    regular: "\f286"
  },
  key: {
    bold: "\f287",
    fill: "\f288",
    regular: "\f289"
  },
  laptop: {
    bold: "\f28a",
    fill: "\f28b",
    regular: "\f28c"
  },
  layer: {
    bold: "\f28d",
    fill: "\f28e",
    regular: "\f28f"
  },
  link: {
    bold: "\f290",
    fill: "\f291",
    regular: "\f292"
  },
  "list-bulleted": {
    bold: "\f293",
    fill: "\f294",
    regular: "\f295"
  },
  "load-balancer-classic": {
    bold: "\f296",
    fill: "\f297",
    regular: "\f298"
  },
  lock: {
    bold: "\f299",
    fill: "\f29a",
    regular: "\f29b"
  },
  "low-volume": {
    bold: "\f29c",
    fill: "\f29d",
    regular: "\f29e"
  },
  "machine-learning-model": {
    bold: "\f29f",
    fill: "\f2a0",
    regular: "\f2a1"
  },
  "magnifying-glass": {
    bold: "\f2a2",
    fill: "\f2a3",
    regular: "\f2a4"
  },
  map: {
    bold: "\f2a5",
    fill: "\f2a6",
    regular: "\f2aa"
  },
  "map-pin": {
    regular: "\f2a7",
    bold: "\f2a8",
    fill: "\f2a9"
  },
  medal: {
    bold: "\f2ab",
    fill: "\f2ac",
    regular: "\f2ad"
  },
  "medicine-alert": {
    bold: "\f2ae",
    fill: "\f2af",
    regular: "\f2b0"
  },
  medicine: {
    bold: "\f2b1",
    fill: "\f2b2",
    regular: "\f2b3"
  },
  "micro-chip-alt": {
    bold: "\f2b4",
    fill: "\f2b5",
    regular: "\f2b6"
  },
  "micro-chip": {
    bold: "\f2b7",
    fill: "\f2b8",
    regular: "\f2b9"
  },
  microscope: {
    bold: "\f2ba",
    fill: "\f2bb",
    regular: "\f2bc"
  },
  minus: {
    bold: "\f2bd",
    fill: "\f2be",
    regular: "\f2bf"
  },
  "mobile-horizontal": {
    bold: "\f2c0",
    fill: "\f2c1",
    regular: "\f2c2"
  },
  "mobile-vertical": {
    bold: "\f2c3",
    fill: "\f2c4",
    regular: "\f2c5"
  },
  money: {
    bold: "\f2c6",
    fill: "\f2c7",
    regular: "\f2c8"
  },
  motorcycle: {
    bold: "\f2c9",
    fill: "\f2ca",
    regular: "\f2cb"
  },
  "note-pencil": {
    regular: "\f2cc",
    bold: "\f2cd",
    fill: "\f2ce"
  },
  openlock: {
    bold: "\f2cf",
    fill: "\f2d0",
    regular: "\f2d1"
  },
  "overflow-menu-vertical": {
    bold: "\f2d2",
    fill: "\f2d3",
    regular: "\f2d4"
  },
  oxygen: {
    bold: "\f2d5",
    fill: "\f2d6",
    regular: "\f2d7"
  },
  "p-o-s": {
    bold: "\f2d8",
    fill: "\f2d9",
    regular: "\f2da"
  },
  package: {
    bold: "\f2db",
    fill: "\f2df",
    regular: "\f2e0"
  },
  "package-delay": {
    bold: "\f2dc",
    fill: "\f2dd",
    regular: "\f2de"
  },
  "paper-plane-right": {
    regular: "\f2e1",
    bold: "\f2e2",
    fill: "\f2e3"
  },
  paperclip: {
    bold: "\f2e4",
    fill: "\f2e5",
    regular: "\f2e6"
  },
  "parallel-screen": {
    bold: "\f2e7",
    fill: "\f2e8",
    regular: "\f2e9"
  },
  password: {
    bold: "\f2ea",
    fill: "\f2eb",
    regular: "\f2ec"
  },
  pause: {
    bold: "\f2ed",
    fill: "\f2ee",
    regular: "\f2ef"
  },
  pencil: {
    bold: "\f2f0",
    fill: "\f2f1",
    regular: "\f2f2"
  },
  percent: {
    regular: "\f2f3",
    bold: "\f2f4",
    fill: "\f2f5"
  },
  "personal-a-enda": {
    bold: "\f2f6",
    fill: "\f2f7",
    regular: "\f2f8"
  },
  phone: {
    regular: "\f2f9",
    bold: "\f2fa",
    fill: "\f2fb"
  },
  "phone-incoming": {
    bold: "\f2fc",
    fill: "\f2fd",
    regular: "\f2fe"
  },
  "phone-outgoing": {
    bold: "\f2ff",
    fill: "\f300",
    regular: "\f301"
  },
  "piggy-bank": {
    bold: "\f302",
    fill: "\f303",
    regular: "\f304"
  },
  pill: {
    bold: "\f305",
    fill: "\f306",
    regular: "\f307"
  },
  "place-location": {
    bold: "\f308",
    fill: "\f309",
    regular: "\f30a"
  },
  play: {
    regular: "\f30b",
    bold: "\f30c",
    fill: "\f30d"
  },
  plus: {
    bold: "\f30e",
    fill: "\f30f",
    regular: "\f310"
  },
  pointer: {
    bold: "\f311",
    fill: "\f312",
    regular: "\f316"
  },
  "pointer-lock": {
    bold: "\f313",
    fill: "\f314",
    regular: "\f315"
  },
  "pool-ladder": {
    bold: "\f317",
    fill: "\f318",
    regular: "\f319"
  },
  "post-history": {
    bold: "\f31a",
    fill: "\f31b",
    regular: "\f31c"
  },
  postit: {
    bold: "\f31d",
    fill: "\f31e",
    regular: "\f31f"
  },
  prohibit: {
    regular: "\f320",
    bold: "\f321",
    fill: "\f322"
  },
  promotion: {
    bold: "\f323",
    fill: "\f324",
    regular: "\f325"
  },
  "protection-checked": {
    bold: "\f326",
    fill: "\f327",
    regular: "\f328"
  },
  qr: {
    bold: "\f329",
    fill: "\f32a",
    regular: "\f32b"
  },
  question: {
    bold: "\f32c",
    fill: "\f32d",
    regular: "\f32e"
  },
  receipt: {
    bold: "\f32f",
    fill: "\f333",
    regular: "\f334"
  },
  "receipt-checked": {
    bold: "\f330",
    fill: "\f331",
    regular: "\f332"
  },
  "reminder-a-enda": {
    bold: "\f335",
    fill: "\f336",
    regular: "\f337"
  },
  renew: {
    bold: "\f338",
    fill: "\f339",
    regular: "\f33a"
  },
  repeat: {
    bold: "\f33b",
    fill: "\f33c",
    regular: "\f340"
  },
  "repeat-purchase": {
    bold: "\f33d",
    fill: "\f33e",
    regular: "\f33f"
  },
  ruc: {
    bold: "\f341",
    fill: "\f342",
    regular: "\f343"
  },
  "ruler-alt": {
    bold: "\f344",
    fill: "\f345",
    regular: "\f346"
  },
  sauce: {
    bold: "\f347",
    fill: "\f348",
    regular: "\f349"
  },
  save: {
    bold: "\f34a",
    fill: "\f34b",
    regular: "\f34c"
  },
  scan: {
    bold: "\f34d",
    fill: "\f34e",
    regular: "\f34f"
  },
  "search-layers": {
    bold: "\f350",
    fill: "\f351",
    regular: "\f352"
  },
  sensor: {
    bold: "\f353",
    fill: "\f354",
    regular: "\f355"
  },
  "settings-alt": {
    bold: "\f356",
    fill: "\f357",
    regular: "\f358"
  },
  "share-network": {
    regular: "\f359",
    bold: "\f35a",
    fill: "\f35b"
  },
  shirt: {
    bold: "\f35c",
    fill: "\f35d",
    regular: "\f35e"
  },
  "shopping-cart": {
    bold: "\f35f",
    fill: "\f360",
    regular: "\f361"
  },
  shrimp: {
    bold: "\f362",
    fill: "\f363",
    regular: "\f364"
  },
  "sign-out": {
    bold: "\f365",
    fill: "\f366",
    regular: "\f367"
  },
  "sliders-horizontal": {
    bold: "\f368",
    fill: "\f369",
    regular: "\f36a"
  },
  soda: {
    bold: "\f36b",
    fill: "\f36c",
    regular: "\f36d"
  },
  "sort-by": {
    bold: "\f36e",
    fill: "\f36f",
    regular: "\f370"
  },
  "soup-dispenser": {
    bold: "\f371",
    fill: "\f372",
    regular: "\f373"
  },
  "soup-noodles": {
    bold: "\f374",
    fill: "\f375",
    regular: "\f376"
  },
  speedometer: {
    bold: "\f377",
    fill: "\f378",
    regular: "\f379"
  },
  sponge: {
    bold: "\f37a",
    fill: "\f37b",
    regular: "\f37c"
  },
  star: {
    regular: "\f37d",
    bold: "\f37e",
    fill: "\f37f"
  },
  "star-half": {
    bold: "\f380",
    fill: "\f381",
    regular: "\f382"
  },
  stop: {
    bold: "\f383",
    fill: "\f384",
    regular: "\f385"
  },
  storefront: {
    bold: "\f386",
    fill: "\f387",
    regular: "\f388"
  },
  "styling-cream": {
    bold: "\f389",
    fill: "\f38a",
    regular: "\f38b"
  },
  "substract-volume": {
    bold: "\f38c",
    fill: "\f38d",
    regular: "\f38e"
  },
  "tablet-horizontal": {
    bold: "\f38f",
    fill: "\f390",
    regular: "\f391"
  },
  "tablet-vertical": {
    bold: "\f392",
    fill: "\f393",
    regular: "\f394"
  },
  tag: {
    regular: "\f395",
    bold: "\f396",
    fill: "\f397"
  },
  temperature: {
    bold: "\f398",
    fill: "\f399",
    regular: "\f39a"
  },
  "thumbs-down": {
    bold: "\f39b",
    fill: "\f39c",
    regular: "\f39d"
  },
  "thumbs-up": {
    bold: "\f39e",
    fill: "\f39f",
    regular: "\f3a0"
  },
  thunder: {
    bold: "\f3a1",
    fill: "\f3a2",
    regular: "\f3a3"
  },
  ticket: {
    bold: "\f3a4",
    fill: "\f3a5",
    regular: "\f3a6"
  },
  toothpaste: {
    bold: "\f3a7",
    fill: "\f3a8",
    regular: "\f3a9"
  },
  trash: {
    bold: "\f3aa",
    fill: "\f3ab",
    regular: "\f3ac"
  },
  "tree-view": {
    bold: "\f3ad",
    fill: "\f3ae",
    regular: "\f3af"
  },
  "trend-down": {
    bold: "\f3b0",
    fill: "\f3b1",
    regular: "\f3b2"
  },
  "trend-up": {
    bold: "\f3b3",
    fill: "\f3b4",
    regular: "\f3b5"
  },
  trophy: {
    bold: "\f3b6",
    fill: "\f3b7",
    regular: "\f3b8"
  },
  truck: {
    bold: "\f3b9",
    fill: "\f3ba",
    regular: "\f3bb"
  },
  tub: {
    bold: "\f3bc",
    fill: "\f3bd",
    regular: "\f3be"
  },
  twitter: {
    bold: "\f3bf",
    fill: "\f3c0",
    regular: "\f3c1"
  },
  undo: {
    bold: "\f3c2",
    fill: "\f3c3",
    regular: "\f3c4"
  },
  upload: {
    bold: "\f3c5",
    fill: "\f3c6",
    regular: "\f3c7"
  },
  "user-avatar": {
    bold: "\f3c8",
    fill: "\f3c9",
    regular: "\f3ca"
  },
  "user-add": {
    bold: "\f3cb",
    fill: "\f3cc",
    regular: "\f3cd"
  },
  user: {
    bold: "\f3ce",
    fill: "\f3cf",
    regular: "\f3d0"
  },
  "user-substract": {
    bold: "\f3d1",
    fill: "\f3d2",
    regular: "\f3d3"
  },
  "user-with-cart": {
    bold: "\f3d4",
    fill: "\f3d5",
    regular: "\f3d6"
  },
  "video-layer": {
    bold: "\f3d7",
    fill: "\f3d8",
    regular: "\f3d9"
  },
  "warning-circle": {
    bold: "\f3da",
    fill: "\f3db",
    regular: "\f3dc"
  },
  "warning-triangle": {
    bold: "\f3dd",
    fill: "\f3de",
    regular: "\f3df"
  },
  whatsapp: {
    bold: "\f3e0",
    fill: "\f3e1",
    regular: "\f3e2"
  },
  "wi-fi": {
    bold: "\f3e3",
    fill: "\f3e4",
    regular: "\f3e8"
  },
  "wi-fi-off": {
    bold: "\f3e5",
    fill: "\f3e6",
    regular: "\f3e7"
  },
  x: {
    bold: "\f3e9",
    fill: "\f3ea",
    regular: "\f3eb"
  },
  youtube: {
    bold: "\f3ec",
    fill: "\f3ed",
    regular: "\f3ee"
  }
}, r = {
  sm: "16px",
  md: "24px",
  lg: "32px",
  auto: "auto"
}, n = c.i`
  font-size: ${(l) => {
  if (l.size !== "auto")
    return r[l.size || "md"];
}};
  width: ${(l) => {
  if (l.size !== "auto")
    return r[l.size || "md"];
}};
  color: ${(l) => l.color ? l.color : l.variant ? {
  primary: l.theme.brandPrimaryMedium,
  highlight: l.theme.brandHighlightMedium,
  darkest: l.theme.colorNeutralDarkest,
  lightest: l.theme.colorNeutralLightest
}[l.variant] : "inherit"};
  &::before {
    content: '${(l) => l.htmlUnicode}';
  }
`, h = ({ weight: l = "regular", variant: e, size: a, name: f, color: d, className: i = "", ...o }) => {
  const b = t[f][l], u = `dl-icon dli-${f}-${l}`;
  return /* @__PURE__ */ g.jsx(
    n,
    {
      htmlUnicode: b,
      size: a,
      color: d,
      variant: e,
      className: `${u} ${i}`,
      ...o
    }
  );
};
export {
  h as I,
  r as i
};
